const WORKOS_OAUTH_ERROR_MESSAGES: Record<string, string> = {
  access_denied: "Sign-in was cancelled at your identity provider.",
  invalid_request: "The sign-in request was invalid. Please try again.",
  server_error: "Your identity provider encountered an error. Please try again later.",
};

/** Human-readable message from WorkOS OAuth error redirect query params. */
export function formatWorkOsOAuthRedirectError(
  error: string,
  errorDescription?: string | null,
): string {
  const description = errorDescription?.trim();
  if (description) {
    return description;
  }

  return (
    WORKOS_OAUTH_ERROR_MESSAGES[error] ??
    `Sign-in failed (${error}). Please contact your administrator.`
  );
}

/** Route back to login and surface the message via `sso_error` (shown as a toast). */
export function buildSsoLoginRedirectUrl(
  message: string,
  options?: { email?: string; sso?: boolean },
): string {
  const params = new URLSearchParams();
  params.set("sso_error", message);
  if (options?.sso !== false) {
    params.set("sso", "true");
  }
  if (options?.email) {
    params.set("email", options.email);
  }
  return `/login?${params.toString()}`;
}
